import { DOCUMENT } from '@angular/common';
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BfAuthService } from '@brafton/skynet-angular-security-service';

import { isAuthBridgeLocation } from './core/auth-bridge-route';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss',
})
export class App {
  private readonly document = inject(DOCUMENT);

  constructor() {
    // Skip all of this on the headless /auth-bridge route. It is a read-only probe
    // in a hidden cross-site iframe: it never completes a login, so there is no
    // callback to listen for — and enableAutoLogout() there would redirect the
    // IFRAME to Auth0's logout endpoint, ending the session in the tab the user is
    // actually working in.
    if (isAuthBridgeLocation(this.document.location)) {
      return;
    }

    // Injected here rather than in a field, deliberately: constructing
    // BfAuthService instantiates Auth0 Lock, which pulls Lock from the CDN and
    // fires cross-origin captcha/SSO probes. A field initializer would run before
    // the guard above and do all of that on the bridge page too.
    const auth = inject(BfAuthService);

    // Must run once, as early as possible: this registers the Auth0 Lock
    // 'authenticated' listener. Login is a redirect flow, so Auth0 returns to
    // this origin with the tokens in the URL fragment and Lock replays them
    // through that listener — if nothing is listening yet, the tokens are
    // dropped and the user bounces back to /login.
    auth.handleAuthentication();

    // Polls the id_token expiry every 60s and logs out ~5 minutes ahead of it.
    auth.enableAutoLogout();
  }
}
